import GrafbaseHead from './head'

export type { GrafbaseHeadProps } from './head'

export default GrafbaseHead
